import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class DeleteBankAccount {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly frontend,
  ) { }

  async run(bank_account_ids:[string]): Promise<any> {
    let args = { 
      bank_account_ids: bank_account_ids
    }
    this.frontend.loading_delete_bank_accounts(true)
    await this.dispatcher.dispatch('delete_bank_account.data', args)
    this.frontend.loading_delete_bank_accounts(false)
  }
}